<material-navbar menuPosition="dashboard"></material-navbar>
<div class="page-body container article-body" [innerHTML]="body"></div>


// WEBPACK FOOTER //
// /mnt/e/apps/architect3/client/node_modules/vebto-client/core/ui/custom-page/custom-page.component.html